import React, { useCallback } from 'react';

interface GameVariableProps {
  containerCount: number,
  colorCount: number,
  gameName: string,
  onGameContainerCountChange:(containerCount:number) => void,
  onGameColorCountChange:(colorCount:number) => void,
  onGameNameChange:(gameName:string) => void
}


function GameVariables({ containerCount = 14, colorCount=12, gameName="", onGameContainerCountChange, onGameColorCountChange, onGameNameChange } : GameVariableProps ) {
 
  const containerCountChanged = (event:React.ChangeEvent<HTMLInputElement>) => {
    onGameContainerCountChange(Number(event.target.value));
    onGameColorCountChange(Number(event.target.value) - 2);
  };

  const colorCountChanged = useCallback((event:React.ChangeEvent<HTMLInputElement>) => {
    onGameColorCountChange(Number(event.target.value));
  }, [onGameColorCountChange]);

  const gameNameChanged = (event:React.ChangeEvent<HTMLInputElement>) => {
    onGameNameChange(event.target.value);
  }


  return (
    <>
      <div className="gameVariables">
        <label>
          Number of Containers:
          <input type="number" name="containerCount" value={containerCount} min="2" max="14" onChange={containerCountChanged} />
        </label>
        <label>
          Number of Colors:
          <input type="number" name="colorCount" value={colorCount} min="2" max="12" onChange={colorCountChanged} />
        </label>
        <label>
          Game name (to save it):
          <input type="text" name="gameName" value={gameName} onChange={gameNameChanged} />
        </label>
      </div>
    </>
  );
  
}

export default GameVariables;
